import moment from "moment"
import { Button, Card, Col, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"

function ReagendarCancelar({t, cita, handleChoice}){
    //console.log(cita)
    const { patientDTO } = cita

    return (
        <Row>
            <Col xs="12" md={{span: 4, offset: 4}}>
                <Card>
                    <Card.Body>
                        <Row>
                            <Col>
                                <label className="mb-1 d-block"><strong>{`Sr(a) ${patientDTO?.name} ${patientDTO?.middleName ?? ''} ${patientDTO?.lastName} ${patientDTO?.seccondSurname ?? ''}`}</strong></label>
                                <label className="mb-1 d-block"><strong>Documento: </strong>{patientDTO ? `${patientDTO?.identityDocumentType?.code ?? ''} ${patientDTO.documentNumber}` : '-'}</label>
                                <label className="mb-1 d-block"><strong>{t('especialidad')}: </strong>{cita.speciality?.name}</label>
                                <label className="mb-1 d-block"><strong>{t('dia_hora')}: </strong>{moment(cita?.scheduleDTO?.dateTimeInit, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm")}</label>
                                <label className="mb-1 d-block"><strong>{t('medico')}: </strong>{cita?.scheduleDTO?.name_doctor}</label>
                                
                                <p className="mt-3 mb-1">Tiempos para cancelación o reagendamiento de cita</p>
                                <ul>
                                    <li>Medicina general y pediatría (2 horas antes).</li>
                                    <li>Otras especialidades (24 horas antes).</li>
                                </ul>
                                <Button type="button" variant="primary" onClick={() => handleChoice(true)}>Reagendar</Button>{' '}
                                <Button type="button" variant="secondary"  onClick={() => handleChoice(false)}>Cancelar</Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

export default withTranslation()(ReagendarCancelar)